import type { RouteRecordRaw } from 'vue-router';

import LegacyShellHost from '@/platform/layout/LegacyShellHost.vue';

// v3-native auth routes. All are marked `authFree` so the global guard skips
// the redirect-to-/login flow.

const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/domains/auth/views/Login.vue'),
    meta: { renderer: 'native', authFree: true },
  },
  // /reset-password and /setup-password share the Login.vue orchestrator.
  // Login.vue chooses the visible step from the current route path.
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('@/domains/auth/views/Login.vue'),
    meta: { renderer: 'native', authFree: true },
  },
  {
    path: '/setup-password',
    name: 'setupPassword',
    component: () => import('@/domains/auth/views/Login.vue'),
    meta: { renderer: 'native', authFree: true },
  },
  // SSO OAuth/SAML callback — IdP redirects here with `?t=<code>`.  No UI
  // beyond a spinner; SsoRedirect.vue exchanges the code for a token and
  // pushes /clusters.
  {
    path: '/sso-redirect',
    name: 'ssoRedirect',
    component: () => import('@/domains/auth/views/SsoRedirect.vue'),
    meta: { renderer: 'native', authFree: true },
  },
  // Account activation email link. Unauthed users must be able to land here
  // from welcome email without being bounced to /login. Reuse Login.vue; the
  // step query in the URL drives which sub-view renders.
  {
    path: '/active-mail',
    name: 'activeMail',
    component: () => import('@/domains/auth/views/Login.vue'),
    meta: { renderer: 'native', authFree: true },
  },
  // Marketplace entry — users land here from AWS/Azure marketplace product
  // pages with `?csp=<aws|azure>&ampt=...` or `?csp=azure&subscriptionId=...`.
  // Posts /marketplace/customer or /marketplace/azure/customer/sign-up
  // depending on CSP, then funnels into the standard signUp success info
  // screen.
  {
    path: '/sign-up',
    name: 'marketplaceSignUp',
    component: () => import('@/domains/marketplace/SignUp.vue'),
    meta: { renderer: 'native', authFree: true },
  },
  // Public passthrough pages. Mark authFree so the global guard does not kick
  // unauthed users back to /login when they click "Terms of Service", hit
  // /status, or land on the error pages.
  //
  // /401 lives in routes/errors.ts under AppLayout so the `minimal`
  // chrome (no sidebar / no flashbar / no trial banner) applies — keep
  // a single record there with authFree=true instead of duplicating it
  // top-level with default chrome.
  {
    path: '/terms-of-use',
    name: 'termsOfUse',
    component: LegacyShellHost,
    meta: { renderer: 'legacy', authFree: true },
  },
  {
    path: '/status',
    name: 'status',
    component: LegacyShellHost,
    meta: { renderer: 'legacy', authFree: true },
  },
];

export default authRoutes;
